<template>
  <div class="my-4" v-show="isVisible && !isMobile()">

    <div class="rounded border-2 border-blue-300 bg-white p-2 flex md:items-center cyan-color mt-6 cyan-bg">
      <zt-icon name="info-circle-solid" class="text-2xl m-2 self-start md:self-center"></zt-icon>
      <div class="flex flex-col md:flex-row">
        <div class="text-lg m-2 md:flex-grow">
          <p>{{$t('message.homeComponent.downloadLinkMobile.availableApp')}}</p>
          <p>{{ $t('message.homeComponent.downloadLinkMobile.authMessage') }}</p>
        </div>

        <div class="flex flex-row items-center md:flex-row md:ml-6 md:justify-center button-section">
          <button class="p-1 md:px-6 bg-black text-white rounded mr-4 padding-inline " @click="redirigirAPagina('apple')">
            <div class="flex items-center">
              <AppStoreIcon />
              <div class="mx-2">
                <p class="text-xs">{{ $t('message.homeComponent.downloadLinkMobile.download') }}</p>
                <p class="text-lg">{{ $t('message.homeComponent.downloadLinkMobile.appStore') }}</p>
              </div>
            </div>
          </button>

          <button class="p-1 md:px-6 bg-black text-white rounded padding-inline " @click="redirigirAPagina('android')">
            <div class="flex items-center">
              <PlayStoreIcon />
              <div class="mx-2 flex flex-col">
                <p class="text-xs">{{ $t('message.homeComponent.downloadLinkMobile.getIt') }}</p>
                <p class="text-lg">{{ $t('message.homeComponent.downloadLinkMobile.googlePlay') }}</p>
              </div>
            </div>
          </button>
        </div>
      </div>
      <div class="inline-block m-2 cursor-pointer" @click="isVisible = false">
        <zt-icon name="times" />
      </div>
    </div>

  </div>
</template>

<script>
import AppStoreIcon from '@/components/commons/Illustrations/graphicSVG/AppStoreIcon'
import PlayStoreIcon from '@/components/commons/Illustrations/graphicSVG/PlayStoreIcon'
export default {
  name: 'DownloadLinkMobileApp',
  components: {
    AppStoreIcon,
    PlayStoreIcon
  },
  data() {
    return {
      isVisible: true,
    }
  },
  methods: {
    redirigirAPagina(so) {
      const urlApple = 'https://apps.apple.com/us/app/sichern-com/id1376623820';
      const urlGoogle = 'https://play.google.com/store/apps/details?id=com.sichern.sichern.v2';
      window.location.href = so === 'apple' ? urlApple : urlGoogle;
    },
   isMobile () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
}
  },
}
</script>

<style lang="scss" scoped>
.cyan-color {
  color: #03a9f4;
}
.cyan-bg {
  background-color: #E1F5FE;
}
@media (max-width: 640px) { 
 .button-section {
  margin-block: 1.5rem;
 }
 .padding-inline {
  padding-inline:  1rem;
 }
 }

</style>